var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyMarkerViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ff4a4a;}.cls-1{opacity:0.34;}.cls-2{opacity:0.45;}.cls-3{fill:#e52525;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body_marker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300,
    cy: 300,
    r: 189.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 300,
    cy: 300,
    r: 85.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMarkerViewEntries);
export default __webpack_public_path__ + "static/media/body_marker_view_entries.2e9a3f14e7224ad58d88f38bf00f577c.svg";
export { ForwardRef as ReactComponent };